import React from "react"
import "./changeLang.css"
import { useLocation } from "@reach/router"
import { navigate } from "gatsby"

function ChangeLang({ fromProject, slug }) {
  const location = useLocation()

  let changeLanguage = (text) => {
    // If the user is trying to change from English to Hebrew
    if (location.pathname.includes("/he") && text === "EN") {
      navigate(location.pathname.substring(3, location.pathname.length), { state: { noChange: true } })
    }
    if (!location.pathname.includes("/he") && text === "HE") {
      // If the user trying to come from English to Hebrew
      navigate(`/he${location.pathname}`, { state: { noChange: true } })
    }
  }

  let handleFromProject = (text) => {
    if (text === "EN" && location.pathname.includes("/he")) {
      navigate(`/projects/${slug}`, { state: { noChange: true } })
    }
    if (text === "HE" && !location.pathname.includes("/he")) {
      navigate(`/he/projects/${slug}`, { state: { noChange: true } })
    }
  }

  return (
    <div id="changeLang">
      <div
        role="button"
        tabIndex={0}
        className={location.pathname.includes("/he") ? "lang active" : "lang"}
        onClick={fromProject ? (e) => handleFromProject(e.target.innerHTML) : (e) => changeLanguage(e.target.innerHTML)}
      >
        HE
      </div>

      <div
        role="button"
        tabIndex={0}
        className={!location.pathname.includes("/he") ? "lang active" : "lang"}
        onClick={fromProject ? (e) => handleFromProject(e.target.innerHTML) : (e) => changeLanguage(e.target.innerHTML)}
      >
        EN
      </div>
    </div>
  )
}

export default ChangeLang
